(function () {
  if (window.BotheGalerieDEInit) return;
  window.BotheGalerieDEInit = true;
  if ((document.documentElement.getAttribute('lang') || '').slice(0, 2) !== 'de') return;

  /* ⚠️ CHAQUE GALERIE EST LIÉE À UN IDENTIFIANT PRODUIT.
     Ce fichier est chargé depuis l'en-tête, donc sur TOUTES les pages. La v1 ne
     vérifiait que la langue : mesuré le 16.09.2026 sur le brouillon, les 16 visuels
     FITNESS-TEE s'injectaient aussi sur HAIR BOOST (20 diapositives) et sur l'IceTea
     (23). Identifiant et non slug : Weglot peut traduire les URL. */
  function idProduit() {
    var m = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
    if (m && m.id) return String(m.id);
    var i = document.querySelector('product-form input[name="product-id"], input[name="product-id"]');
    return i ? String(i.value) : '';
  }

  var BASE = '//www.bo-the.ch/cdn/shop/files/';
  /* format=jpg : PNG photographiques (846 Ko en 1000 px) rendus en JPG à ~105 Ko. `webp` est ignoré. */
  var LARGEURS = [246, 493, 600, 713, 823, 990, 1100, 1206, 1346, 1426, 1646, 1946];

  var CONFIG = {
    /* Infusion FAIS-MOI FONDRE — on GARDE les médias d'origine (mockups substitués par
       bothe-css.liquid, vidéo), on retire les créatives françaises et on insère les
       allemandes juste après le mockup. */
    '5657963266203': {
      mode: 'apres-premier',
      mention: true,
      retirer: ['/files/FMF_fr-'],
      vues: [
        ['FITNESS-TEE_de-00-schmelz-dich-fit.png',   'Bothé FITNESS-TEE – Waage mit Beutel und Trinkflasche gegenüber Würfelzucker, ohne Zuckerzusatz'],
        ['FITNESS-TEE_de-01-problem-loesung.png',    'Bothé FITNESS-TEE – Gegenüberstellung Problem und Lösung mit Trinkflasche'],
        ['FITNESS-TEE_de-02-greifautomat.png',       'Bothé FITNESS-TEE – Greifautomat hebt einen Kraftpapier-Beutel über einem Beutelberg'],
        ['FITNESS-TEE_de-03-smartphone.png',         'Bothé FITNESS-TEE – Frau reicht die Trinkflasche aus einem Smartphone-Bildschirm'],
        ['FITNESS-TEE_de-04-spiegel-hund.png',       'Bothé FITNESS-TEE – Mops vor einem Spiegel neben Beutel und Trinkflasche'],
        ['FITNESS-TEE_de-05-brich-das-eis.png',      'Bothé FITNESS-TEE – Trinkflasche in einem rosa Notfallkasten mit Hammer'],
        ['FITNESS-TEE_de-06-kuehlschrank.png',       'Bothé FITNESS-TEE – Kühlschrank voller Flaschen mit Hibiskus-Eistee'],
        ['FITNESS-TEE_de-07-jeans.png',              'Bothé FITNESS-TEE – lächelnde Frau mit weiter Jeans neben der Trinkflasche'],
        ['FITNESS-TEE_de-08-maximale-hydration.png', 'Bothé FITNESS-TEE – Trinkflasche mit Eis, Hibiskusblüten und Anzeigeskala'],
        ['FITNESS-TEE_de-09-typo-portrait.png',      'Bothé FITNESS-TEE – lachende Frau mit Beutel vor FITNESS-TEE Schriftzug'],
        ['FITNESS-TEE_de-10-kauf-nicht.png',         'Bothé FITNESS-TEE – Trinkflasche mit Hibiskusblüte und grosser Schrift'],
        ['FITNESS-TEE_de-11-grosser-beutel.png',     'Bothé FITNESS-TEE – Frau in Sportkleidung trägt einen übergrossen Beutel'],
        ['FITNESS-TEE_de-12-welle-surf.png',         'Bothé FITNESS-TEE – Trinkflasche vor einer roten Welle mit Surferin'],
        ['FITNESS-TEE_de-13-strasse-tote.png',       'Bothé FITNESS-TEE – Frau mit Stofftasche und Trinkflasche in der Stadt'],
        ['FITNESS-TEE_de-14-komm-in-form.png',       'Bothé FITNESS-TEE – Frau hält die gefüllte Trinkflasche in die Kamera'],
        /* le lifestyle carré : sa source française a été supprimée le 15.09 (HTTP 404),
           il ne peut plus arriver par substitution */
        ['FITNESS-TEE_lifestyle-DE-1x1.png',         'Bothé FITNESS-TEE – Beutel wird in eine Hand ausgegossen, mit Produktvorteilen']
      ]
    },
    /* IceTea FAIS-MOI FONDRE — la galerie allemande REMPLACE entièrement la française
       (7 visuels 1080 px, texte français) par 8 visuels allemands 2000×2000.
       Demande de Nadir le 16.09.2026, allemand seul. */
    '9002698604699': {
      mode: 'remplacer',
      mention: true,
      /* Images de la DESCRIPTION produit (hors galerie) : `33.png` porte « 100% Suisse /
         Sans sucre / Drainant » et l'étiquette Fais-Moi Fondre. Remplacée par son
         équivalent allemand, demande de Nadir le 16.09.2026. */
      description: {
        '/files/33.png': ['FITNESS-ICETEA_de-05-himmel.png', 'Bothé FITNESS-ICETEA – Flasche vor Himmel: 100% Schweiz, ohne Zucker, entwässernd'],
        /* null = RETIRER. « FAIS-MOI FONDRE – Bois, Affine, Répète », sans équivalent
           allemand : retirée de la fiche allemande (Nadir, 16.09.2026). */
        '/files/39.png': null
      },
      retirer: [],
      vues: [
        /* le pack en 1re position : c'est ce qu'on achète (Nadir, 16.09.2026) */
        ['FITNESS-ICETEA_de-06-6er-pack.png',     'Bothé Eistee mit Hibiskus – 6er-Pack à 50 cl'],
        ['FITNESS-ICETEA_de-01-ritual.png',       'Bothé Eistee mit Hibiskus – Frau trinkt aus der Flasche unter blauem Himmel'],
        ['FITNESS-ICETEA_de-02-tennis.png',       'Bothé Eistee mit Hibiskus – Sportlerin in Tennisoutfit trinkt aus der Flasche'],
        ['FITNESS-ICETEA_de-03-laufbahn.png',     'Bothé Eistee mit Hibiskus – Läuferin trinkt im Stadion'],
        ['FITNESS-ICETEA_de-04-kuehlschrank.png', 'Bothé Eistee mit Hibiskus – Kühlschrank voller Flaschen mit Limetten'],
        ['FITNESS-ICETEA_de-05-himmel.png',       'Bothé Eistee mit Hibiskus – Flasche vor Himmel mit Produktvorteilen'],
        ['FITNESS-ICETEA_de-07-zutaten.png',      'Bothé Eistee mit Hibiskus – Flasche mit Hibiskusblüten, Limette und Zimt'],
        ['FITNESS-ICETEA_de-08-splash.png',       'Bothé Eistee mit Hibiskus – Flasche wird geöffnet, Eistee spritzt heraus']
      ]
    }
  };

  var C = null;

  function src(f, w) { return BASE + f + '?width=' + w + '&format=jpg'; }
  function srcset(f) {
    var o = [];
    for (var i = 0; i < LARGEURS.length; i++) o.push(src(f, LARGEURS[i]) + ' ' + LARGEURS[i] + 'w');
    return o.join(',');
  }
  /* les clones héritent des classes d'apparition de Dawn : sans nettoyage ils restent à opacity 0 */
  function rendreVisible(el) {
    el.classList.remove('scroll-trigger', 'scroll-trigger--offscreen', 'animate--fade-in');
    var d = el.querySelectorAll('.scroll-trigger, .scroll-trigger--offscreen');
    for (var i = 0; i < d.length; i++) d[i].classList.remove('scroll-trigger', 'scroll-trigger--offscreen');
  }
  function srcDe(el) {
    var img = el.tagName === 'IMG' ? el : el.querySelector('img');
    return img ? (img.getAttribute('src') || '') + ' ' + (img.getAttribute('srcset') || '') : '';
  }

  /* Modèles clonés UNE fois puis gardés en mémoire : en mode « remplacer » on retire
     tous les originaux, il ne resterait plus rien à cloner au passage suivant. */
  var MODELES = null;
  function capturerModeles(ul) {
    if (MODELES) return MODELES;
    var li = null, lis = ul.querySelectorAll('li.product__media-item:not(.bothe-de-diapo)');
    for (var i = 0; i < lis.length; i++) {
      if (lis[i].querySelector('img') && !lis[i].querySelector('deferred-media, video, iframe')) { li = lis[i]; break; }
    }
    if (!li) return null;
    var th = document.querySelector('.thumbnail-list li.thumbnail-list__item:not(.bothe-de-vignette)');
    var md = document.querySelector('product-modal .product-media-modal__content img:not(.bothe-de-modal)');
    MODELES = { li: li.cloneNode(true), vign: th ? th.cloneNode(true) : null, modal: md ? md.cloneNode(true) : null };
    return MODELES;
  }

  /* Retire les originaux indésirables. Tourne à CHAQUE passage, avant le garde-fou :
     Dawn re-rend la galerie (changement de formule) et remet les médias d'origine. */
  function nettoyer(ul) {
    var noeuds = document.querySelectorAll(
      'li.product__media-item:not(.bothe-de-diapo), li.thumbnail-list__item:not(.bothe-de-vignette), ' +
      'product-modal .product-media-modal__content > *:not(.bothe-de-modal)'
    );
    for (var i = 0; i < noeuds.length; i++) {
      var el = noeuds[i], v = srcDe(el), jeter = C.mode === 'remplacer';
      for (var k = 0; !jeter && k < C.retirer.length; k++) if (v.indexOf(C.retirer[k]) !== -1) jeter = true;
      if (jeter) el.remove();
    }
  }

  /* Mention sous la galerie, demandée par Nadir le 16.09.2026 pour les deux fiches FMF :
     les étiquettes des visuels générés ne reproduisent pas exactement l'emballage livré.
     Écrite directement en allemand (Weglot ne traduit pas ce qu'on crée en JS).
     Placée à la fin de <media-gallery>, HORS de la liste que Dawn re-rend à chaque
     changement de formule ; vérifiée à chaque passage, donc jamais en double. */
  var MENTION = 'Die Etiketten auf den Produktbildern können leicht vom gelieferten Produkt abweichen.';
  function assurerMention() {
    if (!C.mention || document.getElementById('bothe-mention-etiquette')) return;
    var galerie = document.querySelector('media-gallery');
    if (!galerie) return;
    if (!document.getElementById('bothe-mention-style')) {
      var st = document.createElement('style');
      st.id = 'bothe-mention-style';
      st.textContent = '.bothe-mention-etiquette{margin:1.2rem 0 0;font-size:1.25rem;line-height:1.5;' +
        'color:rgba(var(--color-foreground),.62);text-align:center;letter-spacing:.02rem}' +
        '@media screen and (max-width:749px){.bothe-mention-etiquette{font-size:1.15rem;margin-top:.6rem;padding:0 1.5rem}}';
      document.head.appendChild(st);
    }
    var p = document.createElement('p');
    p.id = 'bothe-mention-etiquette';
    p.className = 'bothe-mention-etiquette';
    p.textContent = MENTION;
    galerie.appendChild(p);
  }

  /* Remplace des images de la description. La description sert les fichiers EN TAILLE
     PLEINE (3,3 Mo pour ce PNG) : on pointe donc vers la version CDN 1200 px en JPG.
     Idempotent — une fois remplacée, l'URL ne contient plus la clé. */
  function substituerDescription() {
    if (!C.description) return;
    var cles = Object.keys(C.description);
    var imgs = document.querySelectorAll('img:not(.bothe-de-modal)');
    for (var i = 0; i < imgs.length; i++) {
      var im = imgs[i];
      if (im.closest('.product__media-list, .thumbnail-list')) continue;
      var v = (im.getAttribute('src') || '') + ' ' + (im.getAttribute('srcset') || '');
      for (var k = 0; k < cles.length; k++) {
        if (v.indexOf(cles[k]) === -1) continue;
        var cible = C.description[cles[k]];
        if (cible === null) {
          /* on retire l'image, et son conteneur s'il ne contient plus rien (sinon marge vide) */
          var parent = im.parentElement;
          im.remove();
          while (parent && parent.matches && !parent.matches('.product__description, .rte, body') &&
                 !parent.querySelector('img, video, iframe') && !parent.textContent.trim()) {
            var p2 = parent.parentElement; parent.remove(); parent = p2;
          }
          break;
        }
        im.removeAttribute('srcset'); im.removeAttribute('width'); im.removeAttribute('height');
        im.setAttribute('src', BASE + cible[0] + '?width=1200&format=jpg');
        im.setAttribute('alt', cible[1]);
        break;
      }
    }
  }

  function poser() {
    assurerMention();
    substituerDescription();
    var ul = document.querySelector('.product__media-list');
    if (!ul) return false;
    var M = capturerModeles(ul);      /* AVANT le nettoyage, sinon plus rien à cloner */
    if (!M) return false;
    nettoyer(ul);
    if (ul.querySelector('.bothe-de-diapo')) return false;      /* déjà posé */

    var restes = document.querySelectorAll('.bothe-de-vignette, .bothe-de-modal');
    for (var r = 0; r < restes.length; r++) restes[r].remove();

    var thListe = document.querySelector('.thumbnail-list');
    var modalBoite = document.querySelector('product-modal .product-media-modal__content');
    var remplacer = C.mode === 'remplacer';
    var refDiapo = remplacer ? null : ul.querySelector('li.product__media-item');
    var refVign = remplacer ? null : (thListe ? thListe.children[0] : null);

    C.vues.forEach(function (v, k) {
      var f = v[0], alt = v[1], id = 'bothe-de-' + (k + 1);

      var li = M.li.cloneNode(true);
      li.classList.add('bothe-de-diapo');
      li.classList.toggle('is-active', remplacer && k === 0);
      rendreVisible(li);
      li.id = 'Slide-' + id;
      li.setAttribute('data-media-id', id);
      var boite = li.querySelector('[style*="--ratio"]');
      if (boite) boite.setAttribute('style', '--ratio: 1.0; --preview-ratio: 1.0;');
      var img = li.querySelector('img');
      img.setAttribute('alt', alt);
      img.setAttribute('loading', remplacer && k === 0 ? 'eager' : 'lazy');
      img.setAttribute('srcset', srcset(f));
      img.setAttribute('src', src(f, 1445));
      img.removeAttribute('width'); img.removeAttribute('height');
      if (refDiapo) refDiapo.insertAdjacentElement('afterend', li); else ul.appendChild(li);
      refDiapo = li;

      if (M.vign && thListe) {
        var vi = M.vign.cloneNode(true);
        vi.classList.add('bothe-de-vignette');
        vi.classList.remove('thumbnail-list_item--variant');
        rendreVisible(vi);
        vi.id = 'Slide-Thumbnails-' + id;
        vi.setAttribute('data-target', id);
        var b = vi.querySelector('button');
        if (b) { b.setAttribute('aria-current', remplacer && k === 0 ? 'true' : 'false'); b.setAttribute('aria-label', alt); }
        var vimg = vi.querySelector('img');
        if (vimg) {
          vimg.setAttribute('alt', alt);
          vimg.setAttribute('srcset', src(f, 416) + ' 416w,' + src(f, 832) + ' 832w');
          vimg.setAttribute('src', src(f, 416));
          vimg.removeAttribute('width'); vimg.removeAttribute('height');
        }
        if (refVign) refVign.insertAdjacentElement('afterend', vi); else thListe.appendChild(vi);
        refVign = vi;
      }

      if (M.modal && modalBoite) {
        var mi = M.modal.cloneNode(true);
        mi.classList.add('bothe-de-modal');
        mi.classList.remove('product__media-item--variant');
        mi.setAttribute('data-media-id', id);
        mi.setAttribute('alt', alt);
        mi.setAttribute('srcset', srcset(f));
        mi.setAttribute('src', src(f, 1445));
        mi.removeAttribute('width'); mi.removeAttribute('height');
        modalBoite.appendChild(mi);
      }
    });

    var tot = document.querySelector('.slider-counter--total');
    if (tot) tot.textContent = String(ul.querySelectorAll('li.product__media-item').length);
    var cur = document.querySelector('.slider-counter--current');
    if (cur && remplacer) cur.textContent = '1';
    if (thListe) {
      var vs = thListe.querySelectorAll('li.thumbnail-list__item');
      for (var i = 0; i < vs.length; i++) vs[i].setAttribute('data-media-position', String(i + 1));
    }
    /* Dawn met `sliderItems` en cache avant notre ajout : resetPages() re-interroge le DOM
       (initPages() seul laissait « 1 / von 5 » sur 18 — mesuré le 15.09.2026). */
    document.querySelectorAll('slider-component').forEach(function (s) {
      try {
        if (typeof s.resetPages === 'function') s.resetPages();
        else if (typeof s.initPages === 'function') s.initPages();
      } catch (e) {}
    });
    if (remplacer) ul.scrollLeft = 0;
    window.dispatchEvent(new Event('resize'));
    return true;
  }

  function demarrer() {
    C = CONFIG[idProduit()];
    if (!C) return;                    /* produit sans galerie allemande : on ne touche à rien */
    poser();
    var attente = null;
    new MutationObserver(function () {
      clearTimeout(attente);
      attente = setTimeout(poser, 120);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();

/* =====================================================================================
   PANIER ET BARRE « LIVRAISON OFFERTE » DANS LA LANGUE DU SOUS-DOMAINE (de, it)
   Bothé, 16.09.2026. Bloc indépendant de la galerie : il tourne sur TOUTES les pages.

   1) Tiroir panier. Au chargement il est en allemand (Weglot traduit la page servie),
      mais Dawn le RE-REND après chaque ajout / changement de quantité avec du HTML reçu
      en arrière-plan (/cart/add.js … sections), que Weglot ne traduit pas. Mesuré :
      « Votre panier », « Choisissez votre formule », titre produit français.
      → après chaque « cart-update », on recharge une page légère À TRAVERS le proxy
      Weglot (/search, 208 Ko) et on recopie ses zones panier, déjà traduites.
   2) Barre de livraison offerte : fabriquée par un script inline en français en dur
      (« Plus que CHF … pour la livraison offerte »). Traduite ici dès qu'elle apparaît.
   ===================================================================================== */
(function () {
  if (window.BothePanierLangueInit) return;
  window.BothePanierLangueInit = true;
  var L = (document.documentElement.getAttribute('lang') || '').slice(0, 2);
  var TXT = {
    de: { reste: function (m) { return 'Noch ' + m + ' bis zum kostenlosen Versand'; },
          ok: '<strong>Kostenloser Versand</strong> – geschafft!' },
    it: { reste: function (m) { return 'Ancora ' + m + ' per la spedizione gratuita'; },
          ok: '<strong>Spedizione gratuita</strong> – ce l’hai fatta!' }
  }[L];
  if (!TXT) return;                     /* français : rien à faire */

  function barres() {
    var msgs = document.querySelectorAll('.bothe-ship__msg');
    for (var i = 0; i < msgs.length; i++) {
      var h = msgs[i].innerHTML.trim();
      var m = h.match(/^Plus que\s*(<strong>[^<]*<\/strong>)\s*pour la livraison offerte$/);
      if (m) msgs[i].innerHTML = TXT.reste(m[1]);
      else if (/^<strong>Livraison offerte<\/strong>/.test(h)) msgs[i].innerHTML = TXT.ok;
    }
  }

  /* zones recopiées telles quelles depuis la page traduite, si présentes des deux côtés */
  var ZONES = ['cart-drawer .drawer__inner', '#cart-icon-bubble', '#main-cart-items', '#main-cart-footer'];
  var minuterie = null, generation = 0;
  /* Pendant le rechargement (~1,5 s), le tiroir montre le HTML français de Dawn :
     on l'estompe pour qu'il ne soit pas lu, avec une sécurité si la requête échoue.
     ⚠️ Classe posée sur <body> et non sur les zones : Dawn publie « cart-update » AVANT
     de remplacer le contenu du tiroir, un style posé sur les anciens nœuds serait perdu. */
  function estomper(oui) {
    if (!document.getElementById('bothe-panier-style')) {
      var st = document.createElement('style');
      st.id = 'bothe-panier-style';
      st.textContent = 'body.bothe-panier-maj cart-drawer-items,body.bothe-panier-maj cart-drawer .drawer__header,' +
        'body.bothe-panier-maj cart-drawer .bothe-ship-slot,body.bothe-panier-maj #main-cart-items' +
        '{opacity:.2;transition:opacity .15s}';
      document.head.appendChild(st);
    }
    document.body.classList.toggle('bothe-panier-maj', !!oui);
  }
  var securite = null;
  function retraduirePanier() {
    estomper(true);
    clearTimeout(securite);
    securite = setTimeout(function () { estomper(false); }, 6000);
    clearTimeout(minuterie);
    minuterie = setTimeout(function () {
      var g = ++generation;
      var source = /^\/cart\/?$/.test(location.pathname) ? '/cart' : '/search';
      fetch(source + '?q=bothe-panier&_=' + Date.now(), { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (g !== generation) return;            /* une mise à jour plus récente a pris le relais */
          if (!html) { estomper(false); return; }
          var doc = new DOMParser().parseFromString(html, 'text/html');
          if ((doc.documentElement.getAttribute('lang') || '').slice(0, 2) !== L) { estomper(false); return; } /* pas traduite : on ne touche à rien */
          ZONES.forEach(function (sel) {
            var neuf = doc.querySelector(sel), vieux = document.querySelector(sel);
            if (neuf && vieux) vieux.innerHTML = neuf.innerHTML;
          });
          var cdN = doc.querySelector('cart-drawer'), cdV = document.querySelector('cart-drawer');
          if (cdN && cdV) cdV.classList.toggle('is-empty', cdN.classList.contains('is-empty'));
          barres();
          estomper(false);
        })
        .catch(function () { estomper(false); });
    }, 200);
  }

  function demarrer() {
    barres();
    var evt = (typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) || 'cart-update';
    if (typeof subscribe === 'function') subscribe(evt, retraduirePanier);
    /* Traduction immédiate (avant l'affichage) : un délai anti-rebond était sans cesse
       repoussé par les autres scripts de la page et laissait voir le français ~0,5 s.
       Pas de boucle : barres() ne réécrit que si le texte est encore en français. */
    new MutationObserver(barres).observe(document.documentElement, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();
